import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { useCallback } from 'react';
import { useCampaignSchedulingSelector } from '../../../CampaignWorkflowTab/state/CampaignSettings/selectors/useCampaignSchedulingSelector';

export const useStartTime = () => {
  const { dispatch } = useCampaignEditorContext();

  const { startTime } = useCampaignSchedulingSelector() ?? {};
  const onStartTimeChanged = useCallback(
    (startTime: string) => dispatch({ type: 'SET_CAMPAIGN_START_TIME', payload: { startTime } }),
    [dispatch],
  );

  return {
    startTime,
    onStartTimeChanged,
  };
};
